import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Avatar } from '../../components/Avatar';
import * as Styled from './AppPromo.styles';
import { decorImg, downloadBtns } from './data';

const avatars = ['mapPin', 'bellRinging', 'search'];

const AppPromo = () => {
  const { t } = useTranslation();

  return (
    <Styled.AppPromo id="app-promo">
      <Styled.Card className="glass-border">
        <Styled.Content>
          <Styled.Avatars>
            {avatars.map((avatar) => (
              <Avatar key={avatar} icon={avatar} />
            ))}
          </Styled.Avatars>

          <Styled.Info>
            <Styled.Title variant="h3">{t('homeAppPromo.title')}</Styled.Title>
            <Styled.Text variant="body16">{t('homeAppPromo.text')}</Styled.Text>
          </Styled.Info>

          <Styled.Download>
            {downloadBtns.map(({ href, src, alt }) => (
              <Link key={alt} to={href} target="_blank" rel="noreferrer">
                <Styled.DownloadBtn>
                  <Styled.DownloadImg src={src} alt={alt} />
                </Styled.DownloadBtn>
              </Link>
            ))}
          </Styled.Download>
        </Styled.Content>
      </Styled.Card>

      <Styled.Card className="glass-border">
        <Styled.DecorCircles>
          <Styled.DecorCircle
            initial={{ y: 0, x: 0 }}
            animate={{ y: [-30, 30, -30], x: [15, -15, 15] }}
            transition={{
              duration: 2,
              ease: 'easeInOut',
              repeat: Infinity,
              repeatType: 'reverse',
            }}
          />
          <Styled.DecorCircle
            initial={{ y: 0, x: 0 }}
            animate={{ y: [20, -20, 20], x: [-10, 10, -10] }}
            transition={{
              duration: 2.5,
              ease: 'easeInOut',
              repeat: Infinity,
              repeatType: 'reverse',
            }}
          />
        </Styled.DecorCircles>

        <Styled.DecorImg src={decorImg.src} alt={t('homeAppPromo.decorAlt')} />
      </Styled.Card>
    </Styled.AppPromo>
  );
};

export default AppPromo;
